import { useEffect, useState } from "react";

function Mensa(props) {
    const [data, setMensaData] = useState([]);
    useEffect(() => {
        fetch(`https://sls.api.stw-on.de/v1/locations/${props.location}/menu/${props.date}?time=${props.time}`)
        .then((response) => response.json())
        .then((data) => {
            setMensaData(data);
        })
        .catch((err) => {
            console.log(err.message);
        })
    }, [props.location, props.date, props.time])

    console.log(data)

    return <div className="card">
        <div className="card-body">
            <h5 className="card-title"><i className="fa-solid fa-bowl-food me-2"></i>Mensa Menü</h5>
        </div>
        {data.meals ?
            <ul className="list-group list-group-flush">
                {data.meals.map(meal => (
                    <MensaListItem meal={meal}/>
                ))}
            </ul>
            :
            <div className="card-body">
                Laden ...
            </div>
        }
    </div>
}

function MensaListItem(props) {
    return <li className="list-group-item">
        <p className="h6">{props.meal.lane.name}</p>
        <div className="row">
            <div className="col">
                <p className="h5">{props.meal.name}</p>
            </div>
            <div className="col-auto">
                <p className="h5">{props.meal.price.student}€</p>
            </div>
        </div>
        {props.meal.tags.categories.map(readerMealCategory)}
        {props.meal.tags.allergens.length > 0 && <span className="badge bg-secondary me-1">enthält Allergene</span>}
        {props.meal.tags.additives.length > 0 && <span className="badge bg-secondary me-1">enthält Zusatzstoffe</span>}
        {/*
        <p>{props.categories[0]}</p>
        {props.dietType === "vegan" && <span className="badge bg-success">Vegan</span>}
        {props.dietType === "vegetarian" && <span className="badge bg-success">Vegetarisch</span>}
        {props.dietType === "meat" && <span className="badge bg-warning">Artgerechte Haltung</span>}
        */}
        
    </li>
}

const readerMealCategory = (category) => {
    const getBadgeColorClass = (id) => {
        if (id === "VEGA") return 'bg-success'; //Vegan
        if (id === "VEGT") return 'bg-success'; //Vegatarisch
        return 'bg-primary';
    };
    return <span className={`badge ${getBadgeColorClass(category.id)} me-1`}>{category.name}</span>
}

export default Mensa;